$.initialiseSearch = () => {
  const headerFormInput = document.querySelector('.dropdown__container--search .form-textfield-input');
  const searchForm = document.querySelectorAll('.js-search form');

  if(headerFormInput && searchForm.length) {
    Array.prototype.forEach.call(searchForm, (el) => {
      const headerFormInput = el.querySelector('.form-textfield-input');
      const formField = el.querySelector('.js-form-textfield');
      headerFormInput.addEventListener('keyup', function() {
        const inputValue = headerFormInput.value;
        if(inputValue && inputValue.trim() !== '') {
          formField.classList.remove('form-validation-failed');
        } else {
          formField.classList.add('form-validation-failed');
        }
      })
      el.addEventListener("submit", function(e){
        e.preventDefault();

        const inputValue = headerFormInput.value;
        if(inputValue && inputValue.trim() !== '') {
            headerFormInput.value = inputValue.trim();
            el.submit();
        } else {
          formField.classList.add('form-validation-failed');
        }
      }, false)
    })
  }
};



$.initialiseSearch();
